/** Official wordmark geometry, including its supplied clear-space viewBox. */
export function BrandWordmark({ height = 44 }: { height?: number }) {
  return (
    <>
      <span className="tdo-logomark tdo-brand-glyph-legacy">t.</span>
      <span className="tdo-logoword tdo-brand-glyph-legacy">toddoo</span>
      <svg
        className="tdo-brand-wordmark tdo-brand-glyph-2026"
        style={{ display: 'none' }}
        width={height * 398.83 / 135.85}
        height={height}
        viewBox="0 0 398.83 135.85"
        fill="currentColor"
        role="img"
        aria-label="Toddoo"
        focusable="false"
      >
        <path d="M114.79,108.68c-14.93,0-27.08-12.12-27.08-27.01s12.15-27.01,27.08-27.01,27.08,12.12,27.08,27.01-12.15,27.01-27.08,27.01ZM114.79,65.6c-8.88,0-16.11,7.21-16.11,16.07s7.23,16.07,16.11,16.07,16.11-7.21,16.11-16.07-7.23-16.07-16.11-16.07Z" />
        <path d="M287.09,108.7c-14.93,0-27.08-12.12-27.08-27.01s12.15-27.01,27.08-27.01,27.08,12.12,27.08,27.01-12.15,27.01-27.08,27.01ZM287.09,65.61c-8.88,0-16.11,7.21-16.11,16.07s7.23,16.07,16.11,16.07,16.11-7.21,16.11-16.07-7.23-16.07-16.11-16.07Z" />
        <path d="M344.52,108.7c-14.93,0-27.08-12.12-27.08-27.01s12.15-27.01,27.08-27.01,27.08,12.12,27.08,27.01-12.15,27.01-27.08,27.01ZM344.52,65.61c-8.88,0-16.11,7.21-16.11,16.07s7.23,16.07,16.11,16.07,16.11-7.21,16.11-16.07-7.23-16.07-16.11-16.07Z" />
        <path d="M199.29,27.17h-10.97v32.81c-4.5-3.33-10.07-5.31-16.1-5.31-14.93,0-27.08,12.12-27.08,27.01s12.15,27.01,27.08,27.01,27.08-12.12,27.08-27.01c0-.11,0-54.52,0-54.52ZM172.22,97.75c-8.88,0-16.11-7.21-16.11-16.07s7.23-16.07,16.11-16.07,15.92,7.03,16.1,15.73v.45h0c-.06,8.81-7.26,15.96-16.11,15.96Z" />
        <path d="M256.72,27.17h-10.97v32.81c-4.5-3.33-10.07-5.31-16.1-5.31-14.93,0-27.08,12.12-27.08,27.01s12.15,27.01,27.08,27.01,27.08-12.12,27.08-27.01c0-.11,0-54.52,0-54.52ZM229.65,97.75c-8.88,0-16.11-7.21-16.11-16.07s7.23-16.07,16.11-16.07,15.92,7.03,16.1,15.74v.44h0c-.06,8.81-7.26,15.96-16.11,15.96Z" />
        <path d="M73.48,86.79c0,6.09-4.97,11.05-11.08,11.05s-10.95-4.84-11.07-10.83v-23.06h22.28v-10.94h-22.28v-12.06h-10.97v12.06h-13.13v10.94h13.13v23.18c.19,11.97,10,21.65,22.04,21.65s22.05-9.87,22.05-21.99h-10.97Z" />
      </svg>
    </>
  );
}
